// extracted by mini-css-extract-plugin
export default {"modal":"xQ-z","addItemButton":"yQ-z","plusCircle":"zQ-z","branchVisible":"AQ-z"};